<video [autoplay]='setup.autoplay' [muted]='setup.muted' [loop]='setup.loop' [title]='setup.title' [id]="setup.id"
    class="full-screen-video" [poster]='poster'>
    <source *ngIf="src._mp4" id="mp4_src" [src]="src._mp4" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>
    <source *ngIf="src._3gp" id="3gp_src" [src]="src._3gp" type='video/3gpp; codecs="mp4v.20.8, samr"'>
    <source *ngIf="src._ogv" id="ogg_src" [src]="src._ogv" type='video/ogg; codecs="theora, vorbis"'>
    <source *ngIf="src._webm" id="webm_src" [src]="src._webm" type='video/webm; codecs="vp8, vorbis"'>
    Tu navegador no implementa el elemento <code>video</code>.
</video>